import React from "react";

import { businesses } from "../../assets/images/icons";

interface IProps {
  active: boolean;
  disabled: boolean;
  plus: boolean;
  minus: boolean;
  business: string;
  clicked: any;
}

const CityDialogTab = (props: IProps) => (
  <li onClick={props.clicked}>
    <a
      className={`${props.active ? "active" : ""} ${props.disabled ? "disabled" : ""} ${props.plus ? "plus" : ""} ${props.minus ? "minus" : ""}`}
    >
      <img src={businesses[props.business]} alt={props.business}/>
    </a>
  </li>
)

export default CityDialogTab;
